import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { WHATS_NEW_ITEMS, SEEN_KEY } from '../content/whatsNew';

const NEW_PATHS = WHATS_NEW_ITEMS.map((i) => i.path);
const DWELL_MS  = 5000;

function getSeenPaths(): Set<string> {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || '[]')); }
  catch { return new Set(); }
}

interface VoidNewValue {
  isNew: (path: string) => boolean;
  anyNew: boolean;
}

const VoidNewContext = createContext<VoidNewValue>({ isNew: () => false, anyNew: false });

export function VoidNewProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [seen, setSeen] = useState<Set<string>>(getSeenPaths);

  useEffect(() => {
    const path = location.pathname;
    if (!NEW_PATHS.includes(path) || seen.has(path)) return;
    const t = setTimeout(() => {
      setSeen((prev) => {
        if (prev.has(path)) return prev;
        const next = new Set(prev);
        next.add(path);
        localStorage.setItem(SEEN_KEY, JSON.stringify([...next]));
        return next;
      });
    }, DWELL_MS);
    return () => clearTimeout(t);
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <VoidNewContext.Provider value={{
      isNew:  (path) => NEW_PATHS.includes(path) && !seen.has(path),
      anyNew: NEW_PATHS.some((p) => !seen.has(p)),
    }}>
      {children}
    </VoidNewContext.Provider>
  );
}

export const useVoidNew = () => useContext(VoidNewContext);
